interface RankItem {
  rank: number;
  title: string;
  tag: string;
  heat: string;
  trend: 'up' | 'down' | 'same';
}

const rankingItems: RankItem[] = [
  { rank: 1, title: '星落长河', tag: '古装·权谋', heat: '986万', trend: 'up' },
  { rank: 2, title: '暗夜追踪', tag: '悬疑·刑侦', heat: '872万', trend: 'up' },
  { rank: 3, title: '月之恋人', tag: '韩剧·浪漫', heat: '815万', trend: 'same' },
  { rank: 4, title: '边缘世界', tag: '科幻·烧脑', heat: '763万', trend: 'up' },
  { rank: 5, title: '都市夜话', tag: '职场·情感', heat: '701万', trend: 'down' },
];

export default function SectionRanking() {
  return (
    <section id="ranking" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-3xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-3">
          热度榜单
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">实时热度排行，看看大家都在追什么</p>
        <div className="bg-background-100 rounded-2xl border border-background-200/70 overflow-hidden">
          {rankingItems.map((item, idx) => (
            <div
              key={idx}
              className={`flex items-center gap-4 px-5 py-4 ${
                idx < rankingItems.length - 1 ? 'border-b border-background-200/50' : ''
              } hover:bg-primary-50/30 transition-colors cursor-pointer`}
            >
              <div className="w-8 text-center shrink-0">
                {item.rank <= 3 ? (
                  <span className={`inline-flex items-center justify-center w-7 h-7 rounded-lg text-xs font-bold ${
                    item.rank === 1 ? 'bg-primary-500 text-background-50' :
                    item.rank === 2 ? 'bg-accent-500 text-background-50' :
                    'bg-secondary-500 text-background-50'
                  }`}>
                    {item.rank}
                  </span>
                ) : (
                  <span className="text-sm font-bold text-foreground-400">{item.rank}</span>
                )}
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="font-heading text-sm text-foreground-900">{item.title}</h3>
                <p className="text-xs text-foreground-400">{item.tag}</p>
              </div>
              <div className="text-right shrink-0">
                <p className="text-sm font-bold text-foreground-800">{item.heat}</p>
                <p className="text-[11px] flex items-center justify-end gap-0.5">
                  {item.trend === 'up' ? (
                    <span className="text-accent-600"><i className="ri-arrow-up-fill text-xs"></i>上升</span>
                  ) : item.trend === 'down' ? (
                    <span className="text-foreground-400"><i className="ri-arrow-down-fill text-xs"></i>下降</span>
                  ) : (
                    <span className="text-foreground-400"><i className="ri-subtract-line text-xs"></i>持平</span>
                  )}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}